const styles = {
  subsetStep: {
    margin: '0 40px',
    '@media (maxWidth: 600px)': {
      margin: 0,
    },
    height: '420px',
  },
};

export default styles;
